// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import $ from 'jquery';
import 'fg-frontend/plugins/jquery.targitoHandler';

let afterAjaxRequest = false;
$(document).on('ajaxComplete', function(){
	afterAjaxRequest = true;
});

export default class TargitoHandler extends WebComponent {
	didMount() {
		$(this.element).targitoHandler({
			'debug': false,
			'ajaxLoad': afterAjaxRequest,
		});
	}
}




// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/TargitoHandler.js